var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FForm',{attrs:{"route":"boats","title":"Boat","columns":"2","schema":[
    {
      component: 'FInput',
      key: 'name',
      label: 'Name',
      required: true,
      column: 1
    },
    {
      component: 'FSelect',
      key: 'priority',
      label: 'Priority',
      column: 1,
      items: _vm.priorities,
    },
    {
      component: 'FEditor',
      key: 'description',
      label: 'Description',
      column: 1,
      required: true
    },
    {
      component: 'FGalleryPicker',
      key: 'gallery_id',
      label: 'Image',
      column: 2,
    } ],"submit":_vm.submit},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }